import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  'messages': 0,
  'requests': 0,
  'confirms': 0,
  'lastSeenUsers': {},
  'onlineUsers': []
}

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.messages = action.payload.messages;
      state.requests = action.payload.requests;
      state.confirms = action.payload.confirms;
      state.lastSeenUsers = action.payload.lastSeenUsers;
      state.onlineUsers = action.payload.onlineUsers;
    },
  },
})

export const { setNotifications } = notificationSlice.actions
export default notificationSlice.reducer